export default __webpack_public_path__ + "static/media/8(Green-Life-Hospital-&-Collage).2ea1e7be.jpg";